import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40f057bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=40f057bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f057bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f057bc')) {
      api.createRecord('40f057bc', component.options)
    } else {
      api.reload('40f057bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=40f057bc&scoped=true", function () {
      api.rerender('40f057bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CommentOrder/index.vue"
export default component.exports